// extracted by mini-css-extract-plugin
module.exports = {"CreditScoreComments":"loanPurpose_CreditScoreComments__1Vxxz","Title":"loanPurpose_Title__maKNA","ActionBar":"loanPurpose_ActionBar__1y_pr"};